import React, { useState } from 'react';
import { Palette, Type, Image as ImageIcon, Shield, CheckCircle2 } from 'lucide-react';

const CadastroGrupoCard = ({ onSave, tenantData, userData }) => {
    // ESTADO REAL: Sem placeholders, focado na estrutura de dados endógena
    const [grupoConfig, setGrupoConfig] = useState({
        nome_grupo: "",
        slogan_rodape: "",
        cor_identidade: "#334155", // Lead Gray (Padrão Monte Hermom)
        logo_grupo: null
    });

    // PALETA DE CORES CURADA (Estrita proibição de Blue-600)
    const coresDisponiveis = [
        { nome: 'Lead Gray', hex: '#334155' },
        { nome: 'Deep Burgundy', hex: '#4c0519' },
        { nome: 'Forest Emerald', hex: '#064e3b' },
        { nome: 'Golden Slate', hex: '#422006' },
        { nome: 'Solid Obsidian', hex: '#020617' }
    ];

    return (
        <div className="w-full max-w-5xl mx-auto p-12 bg-[#020617] border-2 border-slate-800 rounded-[5rem] shadow-2xl animate-in fade-in duration-700">
            
            {/* CABEÇALHO DE SOBERANIA */}
            <div className="flex justify-between items-start mb-16 border-b border-slate-800 pb-10">
                <div>
                    <p className="text-rose-600 font-black text-[10px] uppercase tracking-[0.5em] mb-3 italic">
                        Configuração de Instância SaaS
                    </p>
                    <h1 className="text-white font-black text-5xl uppercase tracking-tighter">
                        Identidade do Grupo
                    </h1>
                </div>
                <div className="text-right">
                    <p className="text-slate-500 font-black text-[8px] uppercase tracking-widest">Responsável pela Ativação</p>
                    <p className="text-white font-black text-xs uppercase">{userData.id}</p>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
                
                {/* COLUNA A: DEFINIÇÃO VISUAL */}
                <div className="space-y-12">
                    {/* SELETOR DE COR DE ACENTO */}
                    <div className="flex flex-col gap-5">
                        <label className="text-slate-500 font-black text-[10px] uppercase tracking-widest ml-8 flex items-center gap-2">
                            <Palette className="w-3 h-3 text-rose-900" /> Cor Institucional (Sistema e Laudos)
                        </label>
                        <div className="flex gap-5 p-6 bg-slate-950 rounded-[3rem] border border-slate-900">
                            {coresDisponiveis.map((cor) => (
                                <button
                                    key={cor.hex}
                                    onClick={() => setGrupoConfig({...grupoConfig, cor_identidade: cor.hex})}
                                    className={`w-12 h-12 rounded-full border-4 transition-all hover:scale-110 ${grupoConfig.cor_identidade === cor.hex ? 'border-white' : 'border-transparent'}`}
                                    style={{ backgroundColor: cor.hex }}
                                />
                            ))}
                        </div>
                    </div>

                    {/* UPLOAD LOGOTIPO */}
                    <div className="flex flex-col gap-5">
                        <label className="text-slate-500 font-black text-[10px] uppercase tracking-widest ml-8 flex items-center gap-2">
                            <ImageIcon className="w-3 h-3 text-rose-900" /> Logotipo do Grupo (.PNG Transparente)
                        </label>
                        <div className="h-48 bg-slate-950 border-2 border-dashed border-slate-800 rounded-[4rem] flex flex-col items-center justify-center hover:border-rose-900 transition-all cursor-pointer">
                            <p className="text-slate-700 font-black text-[9px] uppercase tracking-widest">Arraste ou selecione o arquivo</p>
                        </div>
                    </div>
                </div>

                {/* COLUNA B: CONTEXTO INSTITUCIONAL */}
                <div className="space-y-12">
                    {/* NOME DO GRUPO */}
                    <div className="flex flex-col gap-4">
                        <label className="text-slate-500 font-black text-[10px] uppercase tracking-widest ml-8 flex items-center gap-2">
                            <Shield className="w-3 h-3 text-rose-900" /> Nome de Exibição
                        </label>
                        <input 
                            type="text" 
                            className="bg-slate-950 border-2 border-slate-900 rounded-[2.5rem] p-8 text-white font-black text-xs uppercase focus:border-rose-900 outline-none transition-all shadow-inner"
                            value={grupoConfig.nome_grupo}
                            onChange={(e) => setGrupoConfig({...grupoConfig, nome_grupo: e.target.value.toUpperCase()})}
                        />
                    </div>

                    {/* SLOGAN DE RODAPÉ (REVISADO) */}
                    <div className="flex flex-col gap-4">
                        <label className="text-slate-500 font-black text-[10px] uppercase tracking-widest ml-8 flex items-center gap-2">
                            <Type className="w-3 h-3 text-rose-900" /> Slogan Institucional (Rodapé do Laudo)
                        </label>
                        <textarea 
                            rows="4"
                            className="bg-slate-950 border-2 border-slate-900 rounded-[3.5rem] p-10 text-white font-black text-[11px] uppercase focus:border-rose-900 outline-none transition-all resize-none leading-relaxed"
                            value={grupoConfig.slogan_rodape}
                            onChange={(e) => setGrupoConfig({...grupoConfig, slogan_rodape: e.target.value.toUpperCase()})}
                        ></textarea>
                        <p className="text-slate-700 font-black text-[7px] uppercase tracking-[0.2em] ml-6 italic">
                            * Texto centralizado em todas as páginas da documentação técnica.
                        </p>
                    </div>

                    {/* AÇÃO DE SALVAMENTO */}
                    <button 
                        onClick={() => onSave(grupoConfig)}
                        className="w-full bg-white text-slate-950 font-black py-10 rounded-full text-xs uppercase tracking-[0.5em] hover:bg-rose-900 hover:text-white transition-all shadow-luxury flex items-center justify-center gap-4"
                    >
                        ESTABELECER IDENTIDADE DO GRUPO
                        <CheckCircle2 className="w-5 h-5" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CadastroGrupoCard;